import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RegisterModule} from '../Register/register.module';
import { TranslatePipeModule } from '../translate/translate.pipe.module';
import { AuthGuard } from './auth.guard';
import { AuthenticationService } from './authentication.service';
import { LoginComponent } from './login.component';
import { LoginRoutingModule } from './login-routing.module';
import { TranslatePipe } from '../util/translate.pipe';
import { TranslateService } from '../translate/translate.service';
import { MaterialModule } from '../material.module';
import { TRANSLATION_PROVIDERS  } from '../translate/translations';
import {GenericModalModule} from '../modal/generic-modal.module';


@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    LoginRoutingModule,
    MaterialModule,
    TranslatePipeModule,
    RegisterModule,
    GenericModalModule
  ],
  declarations: [
    LoginComponent,
    TranslatePipe
  ],
  exports: [
    TranslatePipe
  ],
  providers: [
    AuthGuard,
    AuthenticationService,
    TranslateService,
    TRANSLATION_PROVIDERS
  ]
})

export class LoginModule {
}
